import { getClient } from '@/lib/restClient';
import { StoreManagementStoreService } from '@/services/StoreManagement/AuthStores/StoreManagementStoreService';

export type StoreManagementAuthStoreUpdateParams = {
  name: string;
  email: string;
  phone_number: string;
  prefecture: string;
  city: string;
  street_address: string;
  building: string | null;
  zip_code: string;
  latitude: number | null;
  longitude: number | null;
  add_feature_ids: number[];
};

export const useStoreManagementAuthStoreUpdate = async (
  id: number,
  params: StoreManagementAuthStoreUpdateParams
): Promise<void> => {
  const storeManagementStoreService = new StoreManagementStoreService(
    getClient()
  );
  return await storeManagementStoreService.update(id, params);
};
